import React from "react";

const HeroVideo1 = ({
  videoSource,
  altText,
  heading,
  text,
  buttontext,
  buttonlink,
}) => {
  return (
    <div className="relative h-[500px] md:h-[500px] lg:h-[400px] overflow-hidden">
      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src={videoSource} type="video/mp4" />
        {altText}
      </video>
      <div className="absolute inset-0 bg-[#000] bg-opacity-50"></div>
      {/* Content */}
      <div className="absolute inset-0 flex items-center justify-center text-center">
        <div className="text-white p-6 max-w-6xl">
          {/* Heading */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-semibold mb-4 sm:mb-6 leading-tight">
            {heading}
          </h1>

          {/* Text */}
          <p className="text-base sm:text-lg md:text-xl leading-relaxed mb-6 sm:mb-8">
            {text}
          </p>

          {/* Optional Button */}
          {buttontext && (
            <a
              href={buttonlink}
              className="relative overflow-hidden py-4 px-8 rounded-md bg-[#BD0E0E] hover:bg-[#fff] text-white hover:text-black border-none cursor-pointer group"
            >
              {buttontext}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroVideo1;
